import {
  Building2, Star, Truck, Award, DollarSign, Mail, Phone 
} from 'lucide-react';
import type { Supplier } from '../../types';

interface SupplierCardProps {
  readonly supplier: Supplier;
  readonly onClick?: () => void;
}

export function SupplierCard({
  supplier, onClick 
}: SupplierCardProps) {
  return (
    <button type="button" onClick={onClick} className="w-full rounded-lg border bg-white p-4 text-left transition-shadow hover:shadow-md">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="rounded-md bg-primary/10 p-2"><Building2 className="h-5 w-5 text-primary" /></div>
          <div>
            <h3 className="font-medium text-gray-900">{supplier.name}</h3>
            <p className="text-sm text-gray-500">{supplier.contactName}</p>
          </div>
        </div>
        <div className="flex items-center gap-1 rounded-full bg-amber-50 px-2 py-1">
          <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
          <span className="text-sm font-medium text-amber-700">{supplier.rating.toFixed(1)}</span>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-1">
        {supplier.categories.map((cat) => (
          <span key={cat} className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700">{cat}</span>
        ))}
      </div>

      <div className="mt-3 grid grid-cols-3 gap-2 text-center text-sm">
        <div className="rounded-md bg-green-50 p-2">
          <Truck className="mx-auto h-4 w-4 text-green-600" />
          <p className="mt-1 font-medium text-green-700">{supplier.onTimeDeliveryRate}%</p>
          <p className="text-xs text-green-600">On-Time</p>
        </div>
        <div className="rounded-md bg-blue-50 p-2">
          <Award className="mx-auto h-4 w-4 text-blue-600" />
          <p className="mt-1 font-medium text-blue-700">{supplier.qualityScore}%</p>
          <p className="text-xs text-blue-600">Quality</p>
        </div>
        <div className="rounded-md bg-purple-50 p-2">
          <DollarSign className="mx-auto h-4 w-4 text-purple-600" />
          <p className="mt-1 font-medium text-purple-700">${(supplier.totalSpend / 1000).toFixed(0)}K</p>
          <p className="text-xs text-purple-600">Spend</p>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-1">
        {supplier.certifications.map((cert) => (
          <span key={cert} className="rounded-full bg-green-100 px-2 py-0.5 text-xs text-green-700">{cert}</span>
        ))}
      </div>

      <div className="mt-3 flex items-center gap-4 text-xs text-gray-500">
        <span className="flex items-center gap-1"><Mail className="h-3 w-3" /> {supplier.contactEmail}</span>
        <span className="flex items-center gap-1"><Phone className="h-3 w-3" /> {supplier.contactPhone}</span>
      </div>
    </button>
  );
}
